export default {
      id: "login-custom-usage",
      viewBox: "0 0 30 15",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-custom-usage",
      toString: function () {
        return this.url;
      }
    }